import { put, takeLatest } from "redux-saga/effects";
import {
  GET_ROOMS,
  GET_ROOMS_INIT,
  GET_ROOMS_SUCCESS,
  GET_ROOMS_FAILED,
  GET_MESSAGES,
  GET_MESSAGES_INIT,
  GET_MESSAGES_SUCCESS,
  GET_MESSAGES_FAILED,
  UPLOAD_FILES,
  UPLOAD_FILES_INIT,
  UPLOAD_FILES_SUCCESS,
  UPLOAD_FILES_FAILED,
  UPDATE_ARCHIVE,
  UPDATE_ARCHIVE_INIT,
  UPDATE_ARCHIVE_SUCCESS,
  UPDATE_ARCHIVE_FAILED,
  GET_ARCHIVE,
  GET_ARCHIVE_INIT,
  GET_ARCHIVE_SUCCESS,
  GET_ARCHIVE_FAILED,
  SEEN_MESSAGES_INIT,
  SEEN_MESSAGES_SUCCESS,
  SEEN_MESSAGES_FAILED,
  SEEN_MESSAGES,
  GET_UNSEEN_MESSAGES_INIT,
  GET_UNSEEN_MESSAGES_SUCCESS,
  GET_UNSEEN_MESSAGES_FAILED,
  GET_UNSEEN_MESSAGES,
} from "./constants";
import { getUtil, postUtil } from "../../services/axiosClient";
import { API } from "../../utils/Constant";
import jwt_decode from "jwt-decode";



export function* getRooms({tenantType }) {
  const getUserDetails = () => {
    var token = sessionStorage.getItem("token") ?? localStorage.getItem("token");
    if (token !== null) {
      return jwt_decode(token);
    }
    return getUserDetails();
  };
  // const user = getUserDetails();

  yield put({ type: GET_ROOMS_INIT });
  try {
    const res = yield getUtil(`${API.GetRooms}?type=${tenantType}`);
    if (res?.status === 200) {
      const { data } = res;
      const { result } = data;
      
      yield put({ type: GET_ROOMS_SUCCESS, payload: result });
    } else {
      yield put({ type: GET_ROOMS_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}
export function* getMessages({ payload }) {
  try {
    yield put({ type: GET_MESSAGES_INIT });
    const res = yield getUtil(
      `${API.GetRoomMessages}?id=${payload.roomId}&Page=${payload.pageCount}&PageSize=${payload.pageSize}`,
      null,
      window._env_.CHAT_API_URL
    );
    if (res?.status === 200) {
      const { data } = res;

      yield put({
        type: GET_MESSAGES_SUCCESS,
        payload: { data: data },
      });
    } else {
      yield put({ type: GET_MESSAGES_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}
export function* uploadFiles({ payload, onSuccess }) {
  yield put({ type: UPLOAD_FILES_INIT });
  try {
    const res = yield postUtil(
      `${API.UploadFile}`,
      payload,
      window._env_.CHAT_API_URL
    );
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: UPLOAD_FILES_SUCCESS, payload: data.result });
      onSuccess();
    } else {
      yield put({ type: UPLOAD_FILES_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* updateArchiveMessage({ payload }) {
  yield put({ type: UPDATE_ARCHIVE_INIT });
  try {
    const res = yield postUtil(API.UpdateArchive, payload);
    if (res?.status === 200) {
      yield put({
        type: UPDATE_ARCHIVE_SUCCESS,
        data: { ...res.data.result },
        isArchived: payload.archive,
      });
    } else {
      yield put({ type: UPDATE_ARCHIVE_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}
export function* getArchiveMessages({ tenantType }) {
  const getUserDetails = () => {
    var token =sessionStorage.getItem("token") ?? localStorage.getItem("token");
    if (token !== null) {
      return jwt_decode(token);
    }
    return getUserDetails();
  };
  const user = getUserDetails();
  const tenantId =
    user[`http://www.aspnetboilerplate.com/identity/claims/tenantId`];

  yield put({ type: GET_ARCHIVE_INIT });
  try {
    const res = yield getUtil(
      API.GetArchive,
      { id: tenantId, type: tenantType,userId : user.UserId },
      window._env_.CHAT_API_URL
    );
    if (res?.status === 200) {
      // if (res?.data && res?.data.length > 0) {
      //   callback(user.sub, res?.data[0].name, res?.data[0].id);
      // }

      yield put({ type: GET_ARCHIVE_SUCCESS, payload: res?.data });
    } else {
      yield put({ type: GET_ARCHIVE_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}
export function* seenMessages({ payload }) {
  yield put({ type: SEEN_MESSAGES_INIT });
  try {
    const res = yield postUtil(API.SeenMessages,payload,window._env_.CHAT_API_URL);
    if (res?.status === 200) {
      yield put({
        type: SEEN_MESSAGES_SUCCESS,
      });
    } else {
      yield put({ type: SEEN_MESSAGES_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getUnSeenMessages({ payload }) {
  try {
    yield put({ type: GET_UNSEEN_MESSAGES_INIT });
    const res = yield getUtil(
      `${API.GetUnSeenMessages}?UserId=${payload}`,
      null,
      window._env_.CHAT_API_URL
    );
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: GET_UNSEEN_MESSAGES_SUCCESS,
        payload: data ,
      });
    } else {
      yield put({ type: GET_UNSEEN_MESSAGES_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}
export function* chat() {
  yield takeLatest(GET_ROOMS, getRooms);
  yield takeLatest(UPLOAD_FILES, uploadFiles);
  yield takeLatest(UPDATE_ARCHIVE, updateArchiveMessage);
  yield takeLatest(GET_ARCHIVE, getArchiveMessages);
  yield takeLatest(GET_MESSAGES, getMessages);
  yield takeLatest(SEEN_MESSAGES, seenMessages);
  yield takeLatest(GET_UNSEEN_MESSAGES, getUnSeenMessages);
}
